import React, { useEffect, useState } from 'react'
import './trade-offer-notification-modal.styles.scss'
import Modal from '@/components/modal/modal.component'
import { useLocation, useNavigate } from 'react-router-dom'
import { UseCloudGameTransactions } from '@/utils/firebase.utils'
import { useSelector } from 'react-redux'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'

const PRIORITY_ORDER = [
  'tradeReversed',
  'tradeCompleted',
  'tradeAwaitingManager',
  'tradeOffer',
  'tradeOfferDeclined',
  'tradePostCancelled',
]

const TradeOfferNotificationModal = ({ gameData, playerData }) => {
  const screenSize = useSelector(state => state.contentData.screenSize)
  const [show, setShow] = useState(false)
  const [pending, setPending] = useState([])
  const [notifType, setNotifType] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!playerData?.newStuff?.length) {
      setShow(false)
      setPending([])
      setNotifType(null)
      return
    }
    for (const type of PRIORITY_ORDER) {
      const matches = playerData.newStuff.filter(n => n.type === type)
      if (matches.length > 0) {
        setPending(matches)
        setNotifType(type)
        setShow(true)
        return
      }
    }
    setShow(false)
    setPending([])
    setNotifType(null)
  }, [playerData])

  async function dismiss(ids) {
    setShow(false)
    if (!location.pathname.includes('/preview/player/')) {
      await UseCloudGameTransactions('markRewardAsViewed', {
        gameId: gameData.gameId,
        playerId: playerData.playerId,
        rewardIdArr: ids,
      })
    }
  }

  async function handleViewTrade() {
    const first = pending[0]
    const ids = pending.map(n => n.id)
    await dismiss(ids)
    const base = location.pathname.includes('/preview/player/')
      ? `/preview/player/${gameData.path}`
      : `/play/${gameData.path}`
    navigate(`${base}/tradeportal/post/${first.tradeId}`)
  }

  async function handleDismiss() {
    await dismiss(pending.map(n => n.id))
  }

  if (!show || pending.length === 0) return null

  const first = pending[0]
  const count = pending.length

  function renderContent() {
    switch (notifType) {
      case 'tradeReversed':
        return (
          <>
            <h2>A trade was <strong>reversed</strong></h2>
            <p className='ton-sub'>
              {first.offererName
                ? <>Your trade with <strong>{first.offererName}</strong> has been reversed by a manager — your items have been returned.</>
                : first.posterName
                  ? <>Your offer in <strong>{first.posterName}</strong>&apos;s trade has been reversed by a manager — your items have been returned.</>
                  : <>A trade you were part of has been reversed by a manager — your items have been returned.</>
              }
            </p>
          </>
        )
      case 'tradeCompleted':
        return (
          <>
            <h2>Trade <strong>completed!</strong></h2>
            <p className='ton-sub'>
              {first.offererName
                ? <>Your trade with <strong>{first.offererName}</strong> has been completed — check what you received!</>
                : first.posterName
                  ? <>Your offer in <strong>{first.posterName}</strong>&apos;s trade was accepted — check what you received!</>
                  : <>A trade you were part of has been completed.</>
              }
            </p>
          </>
        )
      case 'tradeAwaitingManager':
        return (
          <>
            <h2>Offer accepted — <strong>pending review</strong></h2>
            <p className='ton-sub'>
              {first.posterName
                ? <>Your offer in <strong>{first.posterName}</strong>&apos;s trade was accepted and is awaiting manager approval.</>
                : <>Your trade offer was accepted and is awaiting manager approval.</>
              }
            </p>
          </>
        )
      case 'tradeOffer':
        return (
          <>
            <h2>
              {count === 1
                ? <><strong>{first.offererName}</strong> made an offer on your trade!</>
                : <>You have <strong>{count}</strong> new offers on your trades!</>
              }
            </h2>
            <p className='ton-sub'>Head to your trade to review and respond.</p>
          </>
        )
      case 'tradeOfferDeclined':
        return (
          <>
            <h2>Your offer was <strong>declined</strong></h2>
            <p className='ton-sub'>
              {count === 1
                ? first.posterName
                  ? <>Your offer in <strong>{first.posterName}</strong>&apos;s trade was declined.</>
                  : <>Your trade offer was declined.</>
                : <><strong>{count}</strong> of your trade offers were declined.</>
              }
            </p>
          </>
        )
      case 'tradePostCancelled':
        return (
          <>
            <h2>A trade post was <strong>cancelled</strong></h2>
            <p className='ton-sub'>
              {count === 1
                ? first.posterName
                  ? <><strong>{first.posterName}</strong>&apos;s trade post was cancelled — your offer was not fulfilled.</>
                  : <>A trade post you made an offer on was cancelled.</>
                : <><strong>{count}</strong> trade posts you made offers on were cancelled.</>
              }
            </p>
          </>
        )
      default:
        return null
    }
  }

  const dismissLabel = (notifType === 'tradeOffer' || notifType === 'tradeAwaitingManager')
    ? 'Later'
    : 'Dismiss'

  return (
    <Modal
      show={show}
      cancel={handleDismiss}
      cls={screenSize === 'mobile' ? 'full' : 'narrow'}
    >
      <div className={`trade-offer-notification-modal ${screenSize}`}>
        <div className='ton-icon'>
          <ImageContainer
            src='/images/icons/tradeportal.png'
            alt='trade icon'
            className='ton-icon-image'
          />
        </div>

        {renderContent()}

        <hr />
        <div className='ton-buttons'>
          <button className='g-button' onClick={handleDismiss}>
            {dismissLabel}
          </button>
          <button className='g-button primary' onClick={handleViewTrade}>
            View Trade
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default TradeOfferNotificationModal
